<template>
    <form @submit.prevent="submitForm">
        <div class="row">
            <div class="col-md-6">
                <field-text required v-model="form.title" label="عنوان" placeholder=""/>
            </div>
            <div class="col-md-6">
                <field-upload  required v-model="form.download_link" label="فایل" placeholder="" class="browse-fa"/>
            </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
    import ButtonSubmit from "../ButtonSubmit";
    import Alert from "../Alert";
    import FieldPassword from "../fields/FieldPassword";
    import FieldMobile from "../fields/FieldMobile";
    import FieldEmail from "../fields/FieldEmail";

    import mixinForm from "../../mixins/mixinForm";
    import FieldSelect from "../fields/FieldSelect";
    import FieldText from "../fields/FieldText";
    import FieldUpload from "../fields/FieldUpload";

    export default {
        mixins: [mixinForm],
        components: {
            FieldUpload,
            FieldSelect,
            FieldText,
            FieldEmail,
            FieldMobile,
            FieldPassword,
            Alert,
            ButtonSubmit,
        },
        name: "FormDownload",
        data() {
            return {
                action: "fa/v1/downloads",
            }
        },
    }
</script>
<style >
    .custom-file-input~.custom-file-label::after {
        content: "انتخاب";
    }
</style>


// WEBPACK FOOTER //
// src/components/forms/FormDownload.vue